// Adds two years of group runs to event calendar

const manuallyCancelledDates = new Set([
  "7/4",
  "12/24",
  "12/31",
  "1/1",
  "11/28/2024",
]);

export default function addGroupRuns(groupRunData, events, cancelledGroupRuns) {
  const cancelledDates = [];
  for (let i = 0; i < cancelledGroupRuns.length; i++) {
    const cancelledDate = new Date(cancelledGroupRuns[i]);
    cancelledDates.push([
      cancelledDate.getFullYear(),
      cancelledDate.getMonth(),
      cancelledDate.getDate(),
    ]);
  }
  const date = new Date();
  let counter = 0;
  mainLoop: while (counter <= 730) {
    if (counter !== 0) date.setDate(date.getDate() + 1);
    for (let i = 0; i < cancelledDates.length; i++) {
      if (
        date.getFullYear() === cancelledDates[i][0] &&
        date.getMonth() === cancelledDates[i][1] &&
        date.getDate() === cancelledDates[i][2]
      ) {
        console.log("Should cancel:", date);
        continue mainLoop;
      }
    }
    // if (
    //   manuallyCancelledDates.has(`${date.getMonth() + 1}/${date.getDate()}`) ||
    //   manuallyCancelledDates.has(
    //     `${date.getMonth() + 1}/${date.getMonth()}/${date.getFullYear()}`
    //   )
    // ) {
    //   console.log("Cancelled date:", date);
    //   continue mainLoop;
    // }
    const weekday = date.getDay();
    if (
      (weekday === 2 || weekday === 4) &&
      !manuallyCancelledDates.has(`${date.getMonth() + 1}/${date.getDate()}`) &&
      !manuallyCancelledDates.has(
        `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
      )
    ) {
      const newEvent = {};
      newEvent.year = date.getFullYear();
      newEvent.month = date.getMonth();
      newEvent.day = date.getDate();
      newEvent.name = groupRunData.name;
      newEvent.description = groupRunData.description;
      newEvent.location = groupRunData.location;
      newEvent.startHour = parseInt(groupRunData.time.slice(11, 13));
      newEvent.startMinutes = parseInt(groupRunData.time.slice(14, 16));
      events.push(newEvent);
    }

    counter++;
  }
}
